import { ItemType } from '../../features/product-card/product.interface';
import { OfferTypeChecker } from './offer-type-util';
import { OrderHistory, UserOrderDetails } from '../../features/order-history/order-history.interface';
import { PaymentOrderItemData } from '../../features/order-confirmation/order-completion.interface';

/**
 * Check if the order is a shop order.
 *
 * @param order
 */
export function isShopOrder(order: OrderHistory): boolean {
  return Object.prototype.hasOwnProperty.call(order, 'id');
}

export function checkIsMhGoItemFromItemProperties({
  itemType,
  flow,
  offerType,
  formatCode,
}: {
  itemType?: string;
  flow?: string;
  offerType?: string;
  formatCode?: string;
}) {
  return formatCode === 'GO' || OfferTypeChecker.isGo(offerType) || itemType === ItemType.mhGo || flow === ItemType.mhGo;
}

export function isMhGoItem({
  formatCode,
  offerType,
  itemType,
  flow,
}: PaymentOrderItemData | UserOrderDetails): boolean {
  return checkIsMhGoItemFromItemProperties({
    formatCode,
    offerType,
    itemType,
    flow,
  });
}

/**
 * Verifies if the order in my account section is an HE custom store order (Create).
 *
 * @param order
 */
export function isHeCustomStoreOrder(order?: OrderHistory): boolean {
  return (
    order?.userOrderDetails?.some((orderItem) => {
      return OfferTypeChecker.isCreateEbook(orderItem.offerType);
    }) || false
  );
}

/**
 * Verifies if the order in my account section is an HE private store order (Custom).
 *
 * @param order
 */
export function isHePrivateStoreOrder(order?: OrderHistory): boolean {
  return (
    order?.userOrderDetails?.some((orderItem) => {
      return OfferTypeChecker.isCustom(orderItem.offerType);
    }) || false
  );
}
